"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15592],{

/***/ 15592:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_Transition_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1193);
/* harmony import */ var _utils_Dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68722);





function Header2() {
    var ref = useState(false), mobileNavOpen = ref[0], setMobileNavOpen = ref[1];
    var ref1 = useState(true), top = ref1[0], setTop = ref1[1];
    var trigger = useRef(null);
    var mobileNav = useRef(null);
    // close the mobile menu on click outside
    useEffect(function() {
        var clickHandler = function(param) {
            var target = param.target;
            if (!mobileNav.current || !trigger.current) return;
            if (!mobileNavOpen || mobileNav.current.contains(target) || trigger.current.contains(target)) return;
            setMobileNavOpen(false);
        };
        document.addEventListener("click", clickHandler);
        return function() {
            return document.removeEventListener("click", clickHandler);
        };
    });
    // close the mobile menu if the esc key is pressed
    useEffect(function() {
        var keyHandler = function(param) {
            var keyCode = param.keyCode;
            if (!mobileNavOpen || keyCode !== 27) return;
            setMobileNavOpen(false);
        };
        document.addEventListener("keydown", keyHandler);
        return function() {
            return document.removeEventListener("keydown", keyHandler);
        };
    });
    // detect whether user has scrolled the page down by 10px
    useEffect(function() {
        var scrollHandler = function() {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener("scroll", scrollHandler);
        return function() {
            return window.removeEventListener("scroll", scrollHandler);
        };
    }, [
        top
    ]);
    return /*#__PURE__*/ _jsx("header", {
        className: "fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ".concat(!top && "bg-white  blur  shadow-lg"),
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-6xl mx-auto px-5 sm:px-6",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between h-16 md:h-20",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-shrink-0 mr-4",
                        children: /*#__PURE__*/ _jsx(Link, {
                            href: "/",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "block",
                                "aria-label": "Tradly",
                                children: [
                                    " ",
                                    /*#__PURE__*/ _jsxs("svg", {
                                        width: "50",
                                        height: "50",
                                        viewBox: "0 0 126 126",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M63 0C97.7939 0 126 28.2061 126 63C126 97.7939 97.7939 126 63 126C28.2061 126 0 97.7939 0 63C0 28.2061 28.2061 0 63 0Z",
                                                fill: "url(#paint0_linear)"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                opacity: "0.5",
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M63 119C93.9279 119 119 93.9279 119 63C119 32.0721 93.9279 7 63 7C32.0721 7 7 32.0721 7 63C7 93.9279 32.0721 119 63 119Z",
                                                stroke: "white",
                                                "stroke-width": "1.4"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                opacity: "0.5",
                                                "fill-rule": "evenodd",
                                                "clip-rule": "evenodd",
                                                d: "M63 105C86.196 105 105 86.196 105 63C105 39.804 86.196 21 63 21C39.804 21 21 39.804 21 63C21 86.196 39.804 105 63 105Z",
                                                stroke: "white",
                                                "stroke-width": "1.4"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M108.282 44.2442C105.799 38.2551 102.162 32.8652 97.6482 28.3518C88.7809 19.4845 76.5309 14 63 14C49.469 14 37.219 19.4845 28.3517 28.3518C23.8383 32.8652 20.2012 38.2551 17.7178 44.2442",
                                                stroke: "white",
                                                "stroke-width": "15.4",
                                                "stroke-linecap": "round"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M63.0001 14.0001V111.222",
                                                stroke: "white",
                                                "stroke-width": "15.4",
                                                "stroke-linecap": "round"
                                            }),
                                            /*#__PURE__*/ _jsx("defs", {
                                                children: /*#__PURE__*/ _jsxs("linearGradient", {
                                                    id: "paint0_linear",
                                                    x1: "126",
                                                    y1: "0",
                                                    x2: "126",
                                                    y2: "126",
                                                    gradientUnits: "userSpaceOnUse",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("stop", {
                                                            "stop-color": "#2BDBC0"
                                                        }),
                                                        /*#__PURE__*/ _jsx("stop", {
                                                            offset: "1",
                                                            "stop-color": "#13B58C"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs("nav", {
                        className: "hidden md:flex md:flex-grow",
                        children: [
                            /*#__PURE__*/ _jsxs("ul", {
                                className: "flex flex-grow justify-end flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/templates",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-gray-600 hover:text-gray-900 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out",
                                                children: "Templates"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/tutorials",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-gray-600 hover:text-gray-900 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out",
                                                children: "Tutorials"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/blog",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "text-gray-600 hover:text-gray-900 px-3 lg:px-5 py-2 flex items-center transition duration-150 ease-in-out",
                                                children: "Blog"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs(Dropdown, {
                                        title: "Resources",
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/docs/setup",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "font-medium text-sm text-gray-600 hover:text-gray-900 flex py-2 px-5 leading-tight",
                                                        children: "Docs"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/support",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "font-medium text-sm text-gray-600 hover:text-gray-900 flex py-2 px-5 leading-tight",
                                                        children: "Support center"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("ul", {
                                className: "flex flex-grow justify-end flex-wrap items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "/support",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "font-medium text-gray-600 hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out",
                                                children: "Contact Sales"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "https://auth.tradly.app/login",
                                            children: /*#__PURE__*/ _jsx("a", {
                                                className: "font-medium text-gray-600 hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out",
                                                children: "Sign in"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("li", {
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            href: "https://auth.tradly.app/register",
                                            children: /*#__PURE__*/ _jsxs("a", {
                                                className: "btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 ml-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "Get started - FREE!"
                                                    }),
                                                    /*#__PURE__*/ _jsx("svg", {
                                                        className: "w-3 h-3 fill-current text-gray-400 flex-shrink-0 ml-2 -mr-1",
                                                        viewBox: "0 0 12 12",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ _jsx("path", {
                                                            d: "M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z",
                                                            fillRule: "nonzero"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex md:hidden",
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                ref: trigger,
                                className: "hamburger ".concat(mobileNavOpen && "active"),
                                "aria-controls": "mobile-nav",
                                "aria-expanded": mobileNavOpen,
                                onClick: function() {
                                    return setMobileNavOpen(!mobileNavOpen);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-only",
                                        children: "Menu"
                                    }),
                                    /*#__PURE__*/ _jsxs("svg", {
                                        className: "w-6 h-6 fill-current text-gray-900",
                                        viewBox: "0 0 24 24",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ _jsx("rect", {
                                                y: "4",
                                                width: "24",
                                                height: "2"
                                            }),
                                            /*#__PURE__*/ _jsx("rect", {
                                                y: "11",
                                                width: "24",
                                                height: "2"
                                            }),
                                            /*#__PURE__*/ _jsx("rect", {
                                                y: "18",
                                                width: "24",
                                                height: "2"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                ref: mobileNav,
                                children: /*#__PURE__*/ _jsx(Transition, {
                                    show: mobileNavOpen,
                                    tag: "nav",
                                    id: "mobile-nav",
                                    className: "absolute top-full h-screen pb-16 z-20 left-0 w-full overflow-scroll bg-white",
                                    enter: "transition ease-out duration-200 transform",
                                    enterStart: "opacity-0 -translate-y-2",
                                    enterEnd: "opacity-100 translate-y-0",
                                    leave: "transition ease-out duration-200",
                                    leaveStart: "opacity-100",
                                    leaveEnd: "opacity-0",
                                    children: /*#__PURE__*/ _jsxs("ul", {
                                        className: "px-5 py-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/templates",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "flex text-gray-600 hover:text-gray-900 py-2",
                                                        children: "Templates"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/tutorials",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "flex text-gray-600 hover:text-gray-900 py-2",
                                                        children: "Tutorials"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/blog",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "flex text-gray-600 hover:text-gray-900 py-2",
                                                        children: "Blog"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("li", {
                                                className: "py-2 my-2 border-t border-b border-gray-200",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "flex text-gray-600 hover:text-gray-900 py-2",
                                                        children: "Resources"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("ul", {
                                                        className: "pl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx(Link, {
                                                                    href: "/docs/setup",
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        className: "text-sm flex font-medium text-gray-600 hover:text-gray-900 py-2",
                                                                        children: "Docs"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("li", {
                                                                children: /*#__PURE__*/ _jsx(Link, {
                                                                    href: "/support",
                                                                    children: /*#__PURE__*/ _jsx("a", {
                                                                        className: "text-sm flex font-medium text-gray-600 hover:text-gray-900 py-2",
                                                                        children: "Support center"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/support",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "font-medium text-gray-600 hover:text-gray-900 px-5 py-3 flex items-center transition duration-150 ease-in-out",
                                                        children: "Contact Sales"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "https://auth.tradly.app/login",
                                                    children: /*#__PURE__*/ _jsx("a", {
                                                        className: "flex font-medium w-full text-gray-600 hover:text-gray-900 py-2 justify-center",
                                                        children: "Sign in"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("li", {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "https://auth.tradly.app/register",
                                                    children: /*#__PURE__*/ _jsxs("a", {
                                                        className: "btn-sm text-gray-200 bg-gray-900 hover:bg-gray-800 w-full my-2",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                children: "Get started - FREE!"
                                                            }),
                                                            /*#__PURE__*/ _jsx("svg", {
                                                                className: "w-3 h-3 fill-current text-gray-400 flex-shrink-0 ml-2 -mr-1",
                                                                viewBox: "0 0 12 12",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ _jsx("path", {
                                                                    d: "M11.707 5.293L7 .586 5.586 2l3 3H0v2h8.586l-3 3L7 11.414l4.707-4.707a1 1 0 000-1.414z",
                                                                    fill: "#999",
                                                                    fillRule: "nonzero"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Header2)));


/***/ })

}]);